import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { PermissionGuard } from '../guards/permission.guard';
import { SurveyAddonGuard } from '../guards/survey-addon.guard';
import { lazyRouteNamed } from '../lazy-route';

const surveyRunnerPageRoute = lazyRouteNamed(
  () => import('../../pages/surveys/survey-runner-page'),
  'SurveyRunnerPage',
);

export const surveysRoutes: RouteObject[] = [
  {
    path: RoutesList.SURVEYS,
    element: <PermissionGuard permission="SURVEYS" />,
    children: [
      {
        path: '',
        element: <SurveyAddonGuard />,
        children: [
          {
            path: '',
            element: <MainLayout />,
            children: [
              {
                index: true,
                ...lazyRouteNamed(
                  () => import('../../pages/surveys/surveys-list-page'),
                  'SurveysListPage',
                ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: RoutesList.SURVEY_RESPONSE_DETAIL,
    element: <PermissionGuard permission="SURVEYS" />,
    children: [
      {
        path: '',
        element: <SurveyAddonGuard />,
        children: [
          {
            path: '',
            element: <MainLayout />,
            children: [
              {
                index: true,
                ...lazyRouteNamed(
                  () => import('../../pages/surveys/survey-response-detail-page'),
                  'SurveyResponseDetailPage',
                ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: RoutesList.SURVEY_RUNNER,
    element: <PermissionGuard permission="SURVEYS" />,
    children: [
      {
        path: '',
        element: <SurveyAddonGuard />,
        children: [
          {
            path: '',
            element: <MainLayout />,
            children: [{ index: true, ...surveyRunnerPageRoute }],
          },
        ],
      },
    ],
  },
  {
    path: RoutesList.SURVEY_RUNNER_STEP,
    element: <PermissionGuard permission="SURVEYS" />,
    children: [
      {
        path: '',
        element: <SurveyAddonGuard />,
        children: [
          {
            path: '',
            element: <MainLayout />,
            children: [{ index: true, ...surveyRunnerPageRoute }],
          },
        ],
      },
    ],
  },
];
